import React, {
  useState,
  useContext,
  useRef,
  useCallback,
  useEffect
} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {useMediaQuery} from "react-responsive";
import Button from "@material-ui/core/Button";
import {CartContent} from "../CartContent";
import CartIcon from "../../../../icons/CartIcon";
import {Context} from "../../index";
import {useOnClickOutside} from "../../../../utils/use-on-click-outside";

import styles from "./cart.module.scss";

export function Cart({className, forceClosed}) {
  const [isOpen, setIsOpen] = useState(false);
  const {cartItems, onPlatform} = useContext(Context);
  const containerRef = useRef(null);
  const mobileContainerRef = useRef(null);
  const isDesktop = useMediaQuery({minWidth: 940});

  useEffect(() => setIsOpen(false), [forceClosed]);

  const closeCart = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [isOpen]);
  useOnClickOutside(containerRef, closeCart);
  useOnClickOutside(mobileContainerRef, closeCart);

  const cartContent = <CartContent close={closeCart} items={cartItems} />;

  return (
    <div className={classnames(styles.cart, className)} ref={containerRef}>
      <Button
        className={classnames(styles.button, {
          [styles.open]: isOpen,
          [styles.notEmpty]: cartItems.length > 0,
          [styles.buttonVTB]: onPlatform === `vtb`
        })}
        onClick={() => setIsOpen(!isOpen)}
      >
        <CartIcon viewBox="0 0 28 28" />
        {cartItems.length}
      </Button>
      {isOpen &&
        (isDesktop ? (
          cartContent
        ) : (
          <div className={styles.cartMobileContainer}>
            <div ref={mobileContainerRef}>{cartContent}</div>
          </div>
        ))}
    </div>
  );
}

Cart.propTypes = {
  className: PropTypes.string,
  forceClosed: PropTypes.bool
};
